// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import Element from 'element-ui'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css';
import moment from 'moment';
import Cookies from 'js-cookie';

import { getToken } from '@/utils/auth';

// import router from './router';
router.beforeEach((to, from, next) => {
  // console.log("from = "+from.path);
  // console.log("to = "+to.path);
    if(getToken()){
        if(to.path === '/login'){
          next({path:'/home'});
        }
        else {
          next();
        }
    }else{
      next();
    }
})

Vue.prototype.$moment = moment;
// Vue.prototype.$router = router;
Vue.config.productionTip = false
Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})
/* eslint-disable no-new */


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js